import { AfterViewInit, Component, Input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { OrganizationsNavigationProvider } from '../../../organizations/providers/navigation-provider';
import { MatDialog } from '@angular/material/dialog';
import { Exercice } from "../../../common/models/exercice";
import { ConfigProvider } from "../../../config-provider.service";
import { Organization } from "../../../common/models/organization";
import { FilesVideoPlayerDialogComponent } from "../../../files/components/video-player-dialog/video-player-dialog";
import { CommonModule, NgIf } from "@angular/common";
import { MatButton, MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { MatTooltip } from "@angular/material/tooltip";

@Component({
  selector: 'exercices-video-button',
  providers: [],
  styleUrls: ['./video-button.scss'],
  standalone: true,
  imports: [
    NgIf,
    MatIconButton,
    MatIcon,
    MatTooltip,
    TranslateModule,
    MatButton,
  ],
  templateUrl: './video-button.html'
})
export class ExercicesVideoButtonComponent implements AfterViewInit {
    @Input() public iconOnly = false;
    @Input() public exercice: Exercice = new Exercice({});
    @Input() public color = 'primary';
    @Input() public title = 'Play_video';
    @Input() public icon = 'play_circle_outline';
    @Input() public disabled = false;

    private _organization: Organization | null = null;
    constructor(
        public conf: ConfigProvider,
        private _translater: TranslateService,
        private _dialog: MatDialog,
        private _organizationNavigation: OrganizationsNavigationProvider,
    ) {
    }

    public ngAfterViewInit() {
        this._organizationNavigation.getOrganisationFromRoute().subscribe({
            next: (organization: Organization|null) => {
                this._organization = organization;
            },
            error: (error: any) => this.onError(error)
        });
    }

    public onPlayVideoClicked(): void {
        if (this.exercice.video_path && this._organization) {
            this._dialog.open(FilesVideoPlayerDialogComponent, {
                data: {
                    title: this.exercice.name,
                    src: this.conf.storageRootUrl + this.exercice.video_path,
                }
            });
        } else if (this.exercice.video_url) {
            window.open(this.exercice.video_url, '_blank');
        }
    }

    private onError(error: any): void {
      console.error("VideoButton : ", error);
    }
}
